var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./slide.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?id=data-v-43f3cb1e!../../vue-loader/lib/selector?type=template&index=0!./slide.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-swiper/src/slide.vue
// module id = 289
// module chunks = 17 18